import config from '@resn/gozer-core/config';

// get currentDate query string, used in dev to test promos .. it will not work in production.
// example : http://0.0.0.0:9000/?currentDate=2022-12-01 | https://dev.www.oxefit.io/?currentDate=2022-12-01
const params = new URLSearchParams(window.location.search);
const currentDate = params.get('currentDate') ? `?currentDate=${params.get('currentDate')}` : ''

const promotionUrl = `${config.API_ENDPOINT}/promotion/current${currentDate}`;

export const currentPromotion = {}

export const setupPromotion = async () => {
    try {
        const response = await fetch(promotionUrl, { 
            method: 'GET',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
            }})

        const data = await response.json()       

        currentPromotion.bannerText = data.bannerText
        currentPromotion.homeBodyText = data.homeBodyText
        currentPromotion.showCountdown = data.showCountdown || false // countdown enabled or not
        currentPromotion.countdownLabel = data.countdownLabel || '' // label printed before countdown
        // countdown to date could be different from promo end date
        currentPromotion.countdownToDate = data.countdownToDate ? new Date(data.countdownToDate) : null 

    } catch (error) {
        console.log('error while pulling current promotion', error)
    }
}